import { Point } from '../../../../shared/types/mathTypes.ts';
import { ContextMenu, MenuItem } from '../../../components/contextMenu.tsx';
import { CmmConfig } from '../../../types/sharedTypeImpl.ts';


interface Props {
    screenCoords: Point;
    cmmConfig: CmmConfig;
    onOrderChange: (cmmConfig: CmmConfig, direction: 'up' | 'down') => void;
    onClose: () => void;
}

export function CmmConfigContextMenu({
    screenCoords,
    cmmConfig,
    onOrderChange,
    onClose,
}: Props) {

    const menuItems: MenuItem[] = [
        {
            text: 'Move up',
            callback: () => onOrderChange(cmmConfig, 'up'),
        },
        {
            text: 'Move down',
            callback: () => onOrderChange(cmmConfig, 'down'),
        }
    ];

    return (
        <ContextMenu
            isOpen={true}
            position={screenCoords}
            items={menuItems}
            close={onClose}
        />
    );
}
